import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-left":"auto","margin-right":"auto","padding":"8px","width":"100%"} }

import {onMounted, ref} from 'vue';
import { botsService } from '../services/bots.service';
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid


export default /*#__PURE__*/_defineComponent({
  __name: 'JukeboxView',
  setup(__props) {

let videos = ref([]);
let search = ref('');
let gridApi: any = null;

let columns = ref([
    {field: 'code', headerName: 'Code'},
    {field: 'songName', headerName: 'Song'},
    {field: 'artist', headerName: 'Artist'},
    {field: 'game', headerName: 'Game'},
    {field: 'streamer.twitch', headerName: 'Recorded By'},
]);

// let columns = ref([
// {
//     prop: "code",
//     name: "code",
//     sortable: true,
//     filter: 'string',
//     autoSize: true,
// },
// {
//     prop: "songName",
//     name: "Song",
//     sortable: true,
//     filter: 'string',
//     autoSize: true,
//     size: 500,
// },
// {
//     prop: "artist",
//     name: "Artist",
//     sortable: true,
//     filter: 'string',
//     autoSize: true,
//     size: 200,
// },
// {
//     prop: "game",
//     name: "Game",
//     sortable: true,
//     filter: 'string',
//     autoSize: true,
//     size: 200,
// }]);
let rows = ref([]);

function onGridReady(params: any) {
    gridApi = params.api;
}

function onFilterTextBoxChanged(event: any) {

     gridApi.setGridOption(
        'quickFilterText',
        event?.target?.value
    );
}

onMounted(async () => {
    console.log('loaded');
    botsService.getBots().subscribe((bots) => {
        if (bots && bots['twitch_bggjukebox'] && bots['twitch_bggjukebox'].fullVideos.length && bots['twitch_bggjukebox'].fullVideos.length !== rows.value.length ) {
            videos.value = bots['twitch_bggjukebox'].fullVideos || [];
            rows.value = bots['twitch_bggjukebox'].fullVideos || [];
        }
    });
   
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_grid = _resolveComponent("v-grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_text_field, {
        placeholder: "filter",
        modelValue: _unref(search),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : search = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (onFilterTextBoxChanged($event))),
        style: {"width":"250px"}
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_grid, {
      onGridReady: onGridReady,
      class: "ag-theme-quartz-auto-dark",
      rowData: _unref(rows),
      columnDefs: _unref(columns),
      style: {"height":"calc(100% - 80px)"}
    }, null, 8, ["rowData", "columnDefs"])
  ]))
}
}

})